import PlusLogoLight from "@/assets/icons/plus-logo-light.svg";
import Mail from "@/domain/entities/emails/Email";
import { cn } from "@/lib/utils";
import { cva, VariantProps } from "class-variance-authority";

const mailAISummaryVariants = cva(
    "min-w-0 overflow-hidden text-xs text-left ",
    {
        variants: {
            variant: {
                default: "line-clamp-2 my-auto ml-4",
                long: "line-clamp-2 leading-normal",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    },
);

interface MailAISummaryProps extends VariantProps<
    typeof mailAISummaryVariants
> {
    mail: Mail;
    className?: string;
    isSentFolder?: boolean;
}

const MailAISummary = ({
    mail,
    className,
    variant,
    isSentFolder,
}: MailAISummaryProps) => {
    const mailPreview =
        mail.messagePreview.trim() || "Aperçu non disponible pour l'e-mail";

    return (
        <div
            className={cn(
                "flex items-center gap-2 rounded-lg bg-surface-primary p-2 pl-4 pr-5 text-text-subtitle",
                variant === "long" && "min-h-13",
                className,
            )}
        >
            {mail.aiDetails?.mailSummary && !isSentFolder && (
                <>
                    <img alt="" src={PlusLogoLight} />
                    <p className={mailAISummaryVariants({ variant })}>
                        {mail.aiDetails?.mailSummary}
                    </p>
                </>
            )}
            {(!mail.aiDetails?.mailSummary || isSentFolder) && (
                <p className={mailAISummaryVariants({ variant })}>
                    {mailPreview}
                </p>
            )}
        </div>
    );
};

export default MailAISummary;
